import { SxProps } from "@mui/material";
import { OcChartProps } from "./chart";
import { PRODUCTS } from "oc/configs/constants";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface UseOcChartProps {
  variant: OcChartProps["variant"];
}
export const useOcChart = ({ variant }: UseOcChartProps) => {
  const isMobile = useOcIsMobile();

  const chartBoxPadding = () => {
    switch (variant) {
      case PRODUCTS.MYCAFETERIA: {
        if (isMobile) return "16px 0px";
        else return "0px 40px 0px 0px";
      }
      case PRODUCTS.MYLEAVE: {
        if (isMobile) return "5px";
        else return "5px 33px 5px 17px";
      }
      case PRODUCTS.MYTIMESHEET: {
        return undefined;
      }
    }
  };

  const containerBoxPadding: () => SxProps = () => {
    if (isMobile)
      return {
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
      };
    else
      return {
        flexDirection: "row",
      };
  };

  const cutouts: Record<typeof variant, string> = {
    MyCafeteria: "83%",
    MyLeave: "72%",
    MyTimesheet: "72%",
  } as const;

  const sizes: Record<typeof variant, string> = {
    MyCafeteria: "200px",
    MyLeave: "216px",
    MyTimesheet: "300px",
  };

  return {
    cutout: cutouts[variant],
    size: sizes[variant],
    chartBoxPadding: chartBoxPadding(),
    containerBoxPadding: containerBoxPadding(),
  };
};
